import { render, staticRenderFns } from "./CMSBank.vue?vue&type=template&id=5e5989fe&lang=pug"
import script from "./CMSBank.vue?vue&type=script&lang=js"
export * from "./CMSBank.vue?vue&type=script&lang=js"
import style0 from "./CMSBank.vue?vue&type=style&index=0&id=5e5989fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports